export enum TableNames {
    Changes = 'Changes',
    Completations = 'Completations',
    Registrations = 'Registrations',
    VeelaMessages = 'VeelaMessages',
}
